import heroImage from '../assets/hero.png';

export function Hero() {
  return (
    <aside className="hero-panel">
      <div className="hero-frame">
        <img
          src={heroImage}
          alt="Farewell"
          className="hero-image"
        />
        <h1 className="hero-title">
          Open Payments Farewell Messages
        </h1>
      </div>
    </aside>
  );
}
